var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRecepcionEspera = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000328064 159.999H106.667V26.666H33.3337L0.000328064 58.412V159.999Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76217 61.5865H34.9209V31.4277L4.76217 61.5865Z",
    fill: "#64B5F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 86.666H80.0003V94.2851H26.667V86.666ZM26.667 101.904H67.4513V109.523H26.667V101.904ZM26.667 117.142H80.0003V124.761H26.667V117.142ZM26.667 132.38H67.4513V139.999H26.667V132.38Z",
    fill: "#64B5F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.333 46.666C153.333 68.756 135.423 86.666 113.333 86.666C91.243 86.666 73.333 68.756 73.333 46.666C73.333 24.576 91.243 6.66602 113.333 6.66602C135.423 6.66602 153.333 24.576 153.333 46.666Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.333 79.9993C131.741 79.9993 146.666 65.0741 146.666 46.666C146.666 28.2579 131.741 13.3327 113.333 13.3327C94.9249 13.3327 79.9997 28.2579 79.9997 46.666C79.9997 65.0741 94.9249 79.9993 113.333 79.9993ZM113.333 86.666C135.423 86.666 153.333 68.756 153.333 46.666C153.333 24.576 135.423 6.66602 113.333 6.66602C91.243 6.66602 73.333 24.576 73.333 46.666C73.333 68.756 91.243 86.666 113.333 86.666Z",
    fill: "#17CF63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26.666L100.022 38.666L108.889 46.666L100.022 54.686L100 66.666H126.667V54.666L117.778 46.666L126.667 38.686V26.666H100ZM122.222 55.666V62.666H104.444V55.666L113.333 47.666L122.222 55.666Z",
    fill: "#17CF63"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRecepcionEspera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RecepcionEspera.10c31910.svg";
export { ForwardRef as ReactComponent };